<div
  [ngClass]="{
    small: size === 'small',
    medium: size === 'medium',
    large: size === 'large',
    brand: type === 'brand' && !disabled,
    info: type === 'info' && !disabled,
    trend: type === 'trend' && !disabled,
    notification: type === 'notification' && !disabled,
    green: type === 'green' && !disabled,
    catalog: type === 'catalog' && !disabled,
    'brand--disabled': type === 'brand' && disabled,
    'info--disabled': type === 'info' && disabled,
    'notification--disabled': type === 'notification' && disabled,
    'trend--disabled': type === 'trend' && disabled,
    'trend--selected': type === 'trend' && selected
  }"
  class="custom-chip"
  (click)="emitSelectionEvent()">
  @if (icon) {
    <mat-icon
      [ngClass]="{
      'icon-xs': size === 'small',
      'icon-s': size === 'medium',
      'icon-m': size === 'large'
    }" class="icon check-icon">{{ icon }}
    </mat-icon>
  }
  @if (iconColor) {
    <span
      class="chip-color"
      [style.background-color]="iconColor"></span>
  }
  <div
    [ngClass]="{
      'body-xs': size === 'small',
      'body-s': size === 'medium',
      'body-m': size === 'large'
    }"
    class="chip-text">
    {{ text }}
  </div>
  @if (closed) {
    <button
      (click)="emitCloseEvent()"
      [disabled]="disabled"
      class="chip-button">
      <mat-icon
        [ngClass]="{
        'icon-xs': size === 'small',
        'icon-s': size === 'medium',
        'icon-m': size === 'large'
      }"
        class="icon cancel-icon"
      >cancel
      </mat-icon>
    </button>
  }
</div>
